export default __webpack_public_path__ + "static/media/facebook-original.751cd200.svg";